import React, { lazy } from "react";

const LazyCreateRule = lazy(() => import("./CreateRule"));

const CreateRule = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCreateRule {...props} />;

export default CreateRule;
